import { useEffect, useState } from "react"

const DEFAULT_DATA = {
  Amazonas: {
    Atures: ["Fernando Girón Tovar", "Luis Alberto Gómez", "Platanillal"],
  },
  Anzoátegui: {
    Sotillo: ["Pozuelos", "Puerto La Cruz"],
    Bolívar: ["Bergantín", "Naricual"],
    "Simón Bolívar": ["El Carmen", "San Cristóbal"],
  },
  Apure: { "San Fernando": ["El Recreo", "San Rafael de Atamaica"] },
  Aragua: { Girardot: ["Madre María", "Las Delicias", "Joaquín Crespo"] },
  Barinas: {
    Barinas: ["Rómulo Betancourt", "Alfredo Arvelo", "San Silvestre"],
  },
  Bolívar: { Caroní: ["Cachamay", "Chirica", "Simón Bolívar"] },
  Carabobo: {
    Valencia: ["Candelaria", "San José", "Santa Rosa", "Miguel Peña"],
    Naguanagua: ["Naguanagua"],
  },
  Cojedes: { "Ezequiel Zamora": ["San Carlos de Austria", "Juan Ángel Bravo"] },
  "Delta Amacuro": {
    Tucupita: ["Argimiro García", "San José", "Virgen del Valle"],
  },
  "Distrito Capital": {
    Libertador: [
      "Altagracia",
      "San Bernardino",
      "El Recreo",
      "Candelaria",
      "San Pedro",
    ],
  },
  Falcón: { Carirubana: ["Punta Cardón", "Carirubana", "Norte"] },
  Guárico: { "Francisco de Miranda": ["Calabozo"] },
  Lara: { Iribarren: ["Catedral", "Concepción", "Santa Rosa", "Tamaca"] },
  Mérida: { Libertador: ["Spinetti Dini", "El Llano", "Sagrario"] },
  Miranda: {
    Sucre: [
      "Petare",
      "Leoncio Martínez",
      "Caucagüita",
      "Filas de Mariche",
      "La Dolorita",
    ],
    Chacao: ["Chacao", "El Pedregal", "Altamira"],
    Baruta: ["Baruta", "El Cafetal", "Las Minas de Baruta"],
  },
  Monagas: { Maturín: ["Alto de Los Godos", "Boquerón", "San Simón"] },
  "Nueva Esparta": { Maneiro: ["Aguirre", "Pampatar"] },
  Portuguesa: { Guanare: ["Córdoba", "Guanaguanare", "San Juan"] },
  Sucre: { Sucre: ["Altagracia", "Cariaco", "Casanay"] },
  Táchira: {
    "San Cristóbal": ["La Concordia", "Pedro María Morantes", "San Sebastián"],
  },
  Trujillo: { Trujillo: ["Chiquinquirá", "Cristóbal Mendoza", "Matriz"] },
  Vargas: { Vargas: ["Caraballeda", "Carayaca", "Catia La Mar"] },
  Yaracuy: { "San Felipe": ["Albarico", "San Javier"] },
  Zulia: {
    Maracaibo: [
      "Coquivacoa",
      "Olegario Villalobos",
      "Chiquinquirá",
      "Juana de Ávila",
    ],
  },
}

export function useLocationFilters(initialLocation = {}) {
  const [data, setData] = useState({})
  const [estado, setEstado] = useState(initialLocation?.estado || "")
  const [municipio, setMunicipio] = useState(initialLocation?.municipio || "")
  const [parroquia, setParroquia] = useState(initialLocation?.parroquia || "")

  useEffect(() => {
    let cancelled = false
    const load = async () => {
      try {
        const r = await fetch("/data/ve_locations.json", { cache: "no-store" })
        if (!r.ok) throw new Error("no ok")
        const j = await r.json()
        if (!cancelled) setData(j || DEFAULT_DATA)
      } catch (e) {
        setData(DEFAULT_DATA)
      }
    }
    load()
    return () => {
      cancelled = true
    }
  }, [])

  const estados = Object.keys(data || {})
  const municipios = estado ? Object.keys(data[estado] || {}) : []
  const parroquias = estado && municipio ? data[estado][municipio] || [] : []

  return {
    estado,
    setEstado,
    municipio,
    setMunicipio,
    parroquia,
    setParroquia,
    estados,
    municipios,
    parroquias,
  }
}
